import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Heading, Button, Stack, StackDivider, HStack, Spacer, Text } from '@chakra-ui/react';
import {useApiProvider} from '../../../../../api/ApiProvider';
import ErrorMessage from '../../../../parts/ErrorMessage';
import { ReserveScoutCensusSummaryForm } from './ReserveScoutCensusSummaryForm';
import { useAuth } from '../../../../../auth/AuthProvider';

const ReserveScoutCensusSummary: React.FC = () => {
    const provider = useApiProvider();
    const navigate = useNavigate();
    const { user } = useAuth();

    const loc = useLocation();
    const data: ReserveScoutCensusSummaryForm = loc.state.data;
    const [submitting, setSubmitting] = useState<boolean>(false);
    const [apiCallError, setApiCallError] = useState<string>("");


    const onSubmit = () => {

        setSubmitting(true);
        setApiCallError("");

        provider.postCensus({
            RegistrantId: user?.Id,
            Request: "rezerwa",
            RegistrantComment: data.comment,
            YPSResidence: "not required",
            YPSCitizenship: "not required",
            YPSAccept: false,
            YPSKRKSent: false,
        })
            .then(data => navigate("/"))
            .catch(err => setApiCallError(err))
            .finally(() => setSubmitting(false));
    };


    const onBack = () => {
        navigate('/scout-census', { state: { data: loc.state.data } })
    }

    return (
        <Box
            minHeight="100vh"
            width="100vw"
            backgroundImage="url('/images/forest.jpg')"
            backgroundSize="cover"
            backgroundPosition="center"
            display="flex"
            justifyContent="center"
            alignItems="center"
        >
            <Box
                bg="white"
                padding="5"
                margin="8"
                borderRadius="md"
                boxShadow="lg"
                textAlign="left"
                width="500px"
            >
                <Heading
                    padding="3"
                    as="h2"
                    size="lg"
                    textAlign="center"
                >
                    Podsumowanie arkusza spisowego - Rezerwa
                </Heading>

                {data ? (
                    <Stack divider={<StackDivider />} spacing='4'>
                        <Box>
                            <Heading size='xs' textTransform='uppercase'>Uwagi</Heading>
                            <HStack>
                                <Text pt='2' fontSize='sm'>{data.comment}</Text>
                                <Spacer />
                            </HStack>
                        </Box>
                        <Spacer />
                    </Stack>
                ) : (
                    <Text pt='2' fontSize='sm' textTransform='uppercase'>
                        brak danych
                    </Text>
                )}

                <ErrorMessage text={apiCallError} />
                <Button width="full" colorScheme="brand" onClick={onSubmit} isLoading={submitting}>Zarejestruj</Button>
                <Button width="full" onClick={onBack}>Powrót</Button>
            </Box>
        </Box>
    );
};

export default ReserveScoutCensusSummary;